import { render, staticRenderFns } from "./CataloguePage.vue?vue&type=template&id=a8c679d2&scoped=true&"
import script from "./CataloguePage.vue?vue&type=script&lang=js&"
export * from "./CataloguePage.vue?vue&type=script&lang=js&"
import style0 from "./CataloguePage.vue?vue&type=style&index=0&id=a8c679d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c679d2",
  null
  
)

export default component.exports